import { useRef, useState } from "react";
import { WegetAnswerField } from "./wegets/weget-answer-field";
import styled from 'styled-components';
import { SellertoolSignatureUtils } from "../../utils/sellertool-signature-utils";
import { useApiInfoContextValueHook } from "../../contexts/ApiInfoContextProvider";
import axios from "axios";
import { customToast } from "../../components/toast/custom-react-toastify/v1";
import CustomBlockButton from "../../components/button/CustomBlockButton";

const StyledContainer = styled.div`
    padding: 10px;
    padding-bottom: 200px;
`;

const StyledFloatingBottom = styled.div`
    position: fixed;
    bottom: 20px;
    left: 0;
    width: 100%;
    
    background-color: none;
    /* padding: 10px; */
    z-index: 1000;
    

    .wrapper{
        width: 90%;
        margin: 0 auto;
        display: flex;
    }

    textarea{
        width: 100%;
        min-height: 50px;
        max-height: 120px;
        padding: 10px;
        border-radius: 5px;
        border: 1px solid #ccc;
        resize: none;
    }
    button{
        margin-left: 10px;
        height: 40px;
        width: 80px;
        background-color: #007bff;
        color: #fff;
        border: none;
        border-radius: 5px;
        cursor: pointer;

        &:hover{
            background-color: #0056b3;
        }
    }
`;

const API_HOST = process.env.REACT_APP_MAIN_API_HOST;

export function MainView(props) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const scrollRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [question, setQuestion] = useState('');
    const [qnas, setQnas] = useState([]);

    const handleReqWarehousingQna = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const trimedQuestion = question.trim();

        const currentQnas = [...qnas, {
            question: trimedQuestion,
            answer: '',
            timestamp: new Date()
        }];
        setQuestion('');

        // 미리 세팅해서 렌더링을 가져오고 나중에 결과값으로 덮어쓰기
        setQnas(currentQnas);

        const fetchResult = await axios.post(`${API_HOST}/aichat/warehousing/qna`, {
            qnas: currentQnas,
        }, {
            headers: headers
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                console.log(err.response);
                // filter out the last question
                setQnas(prev => {
                    const newQnas = [...prev];
                    newQnas.pop();
                    return newQnas;
                })
                customToast.error(err.response?.data?.message || '오류가 발생했습니다.');
            });

        if (fetchResult?.content) {
            setQnas(fetchResult?.content?.qnas);
        }
    };

    const prevQnas = qnas?.slice(0, qnas?.length - 1);
    const lastQna = qnas?.[qnas?.length - 1];

    return (
        <>
            <StyledContainer>
                {prevQnas?.map((qna, index) => {
                    return (
                        <WegetAnswerField
                            key={index}
                            answer={qna?.answer || ''}
                            question={qna?.question || ''}
                            typewriter={false}
                            timestamp={new Date(qna?.timestamp) || new Date()}
                        />
                    );
                })}
                <WegetAnswerField
                    answer={lastQna?.answer || '안녕하세요! 저는 AI 어시스턴트입니다. 무엇을 도와드릴까요?'}
                    question={lastQna?.question || ''}
                    typewriter={true}
                    loading={loading}
                    timestamp={new Date(lastQna?.timestamp)}
                />
                <div ref={scrollRef}></div>
                <StyledFloatingBottom>
                    <div className='wrapper'>
                        <textarea
                            value={question}
                            onChange={(e) => setQuestion(e.target.value)}
                            placeholder="질문을 입력하세요"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    const v = question.trim();
                                    if (v) {
                                        setLoading(true);
                                        handleReqWarehousingQna().then(() => {
                                            setLoading(false);
                                        });
                                    }
                                }
                            }}
                        ></textarea>
                        <CustomBlockButton
                            type='button'
                            onClick={() => {
                                setLoading(true);
                                handleReqWarehousingQna().then(() => {
                                    setLoading(false);
                                });
                            }}
                        >
                            전송
                        </CustomBlockButton>
                    </div>
                </StyledFloatingBottom>
            </StyledContainer>
        </>
    );
}